<template>
  <transition name="modal-fade-slide">
    <div v-show="show" class="modal fade show" id="modal" tabindex="-1">
      <transition name="modal-dialog-slide">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Detalhe Histórico API</h5>
              <button class="btn-close-modal" @click="close">
                <i class="fa-regular fa-x"></i>
              </button>
            </div>
            <div class="modal-body">
              <div ref="conteudoParaCopiar">
                <!-- Exibe a lista de itens -->
                <div v-if="dadosModal.itens && dadosModal.itens.length > 0">
                  <table
                   
                    
                    class="table table-striped entrada"
                  >
                    <thead>
                      <tr>
                        <th>Itens:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  v-for="(item, index) in dadosModal.itens" :key="index">
                        <td>{{ item.detalhe }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="close">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalHistoricoComponent",
  props: {
    show: Boolean,
    dadosModal: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-slide-enter-active,
.modal-fade-slide-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.modal-fade-slide-enter,
.modal-fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}
</style>
